<template>
  <v-container>
    <v-row v-if="linkedServicesItems.length > 0 && servicesIds.length > 0">
      <h5 class="subheading">Available Linked Services</h5>
    </v-row>
    <v-row>
      <v-col>
        <v-progress-circular
          v-if="this.$apollo.loading"
          indeterminate
          :width="2"
          :size="25"
        ></v-progress-circular>
      </v-col>
    </v-row>
    <v-row>
      <linked-service-item
        v-for="linkedService in linkedServicesItems"
        :key="linkedService.id"
        :value="linkedService"
        :header-props="headerProps"
        :rate-plan="ratePlan"
        @save="onSave"
      ></linked-service-item>
    </v-row>

    <v-row v-if="debug">
      <v-col>
        <code>{{ serviceLinkedServicesInfo }}</code>
        <code> {{ serviceId }} </code>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../../../helpers";
import LinkedServiceItem from "./LinkedServiceItem.vue";
const randomize = require("randomatic");
const AVAILABLE_LINKED_SERVICES = gql`
  query availableLinkedServices(
    $destinationId: ID!
    $agentId: ID!
    $department: String
    $startDate: DateTimeType
    $endDate: DateTimeType
    $serviceType: GtServiceType
    $adults: String
    $children: String
    $infants: String
    $first: Int
    $services: [ID]
    $marketplace: Boolean
  ) {
    availableLinkedServices: availableServices(
      searchParams: {
        destinationId: $destinationId
        agentId: $agentId
        department: $department
        startDate: $startDate
        endDate: $endDate
        serviceType: $serviceType
        adults: $adults
        children: $children
        infants: $infants
      }
      filter: { services: $services }
      first: $first
      marketplace: $marketplace
    ) {
      edges {
        node {
          id
          serviceName
          serviceId
          supplierName
          supplierId
          priceFrom
          priceFromCurrencyCode
          rateTypeCode
          supplier {
            id
            serviceType
          }
          service {
            id
            stdOccupancy
          }
        }
      }
    }
  }
`;
const SERVICE_LINKED_SERVICES_INFO = gql`
  query serviceLinkedServicesInfo(
    $filter: LinkedServiceFilterType
    $marketplace: Boolean
  ) {
    serviceLinkedServicesInfo: linkedServices(
      filter: $filter
      marketplace: $marketplace
    ) {
      edges {
        node {
          id
          targetService {
            id
            name
            notInUse
          }
          dateFrom
          dateTo
          isMandatory
          notInUse
        }
      }
    }
  }
`;
export default {
  name: "item-linked-services-list",
  components: {
    LinkedServiceItem,
  },
  props: {
    servicesIds: {
      type: Array,
      required: true,
      default: () => [],
    },
    destinationId: {
      type: String,
      required: true,
    },
    agentId: {
      type: String,
      required: true,
    },
    department: {
      type: String,
      required: true,
    },
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    },
    serviceType: {
      type: String,
      required: true,
    },
    adults: {
      type: String,
      required: true,
    },
    children: {
      type: String,
      required: true,
    },
    infants: {
      type: String,
      required: true,
    },
    ratePlan: {
      type: String,
      default: () => null,
    },
    headerProps: {
      type: Object,
      required: true,
    },
    itemLinkedServices: {
      type: Array,
      default: () => [],
    },
    serviceId: {
      type: String,
      default: () => "",
    },
    marketplace: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      debug: false,
      first: 100,
      linkedServicesItems: [],
    };
  },

  computed: {
    serviceLinkedServicesData() {
      return this.serviceLinkedServicesInfo &&
        this.serviceLinkedServicesInfo.edges.length > 0
        ? this.serviceLinkedServicesInfo.edges.map(removeGQLTypename)
        : [];
    },
  },

  watch: {
    itemLinkedServices(newVal) {
      this.linkedServicesItems = this.getLinkedServicesItems();
    },
  },

  methods: {
    getLinkedServicesItems() {
      return this.availableLinkedServices &&
        this.availableLinkedServices.edges.length > 0
        ? this.availableLinkedServices.edges
            .map(removeGQLTypename)
            .map((item) => {
              const itemLinkedService = this.itemLinkedServices.find(
                (service) =>
                  item.service && service.serviceId === item.service.id
              );
              const serviceLinkedServicesInfo =
                this.serviceLinkedServicesData.find(
                  (ls) => ls.targetService.id === item.service.id
                );
              const isMandatory = serviceLinkedServicesInfo
                ? serviceLinkedServicesInfo.isMandatory
                : false;
              const notInUse = serviceLinkedServicesInfo
                ? serviceLinkedServicesInfo.notInUse
                : false;
              return {
                id: randomize("Aa0", 10),
                ...item,
                serviceId: item.service ? item.service.id : item.id,
                startDate: itemLinkedService
                  ? itemLinkedService.startDate
                  : this.startDate,
                endDate: itemLinkedService
                  ? itemLinkedService.endDate
                  : this.endDate,
                adults: itemLinkedService
                  ? itemLinkedService.adults.toString()
                  : this.adults,
                children: itemLinkedService
                  ? itemLinkedService.children.toString()
                  : this.children,
                infants: itemLinkedService
                  ? itemLinkedService.infants.toString()
                  : this.infants,
                qty: itemLinkedService ? itemLinkedService.qty : 1,
                serviceType: item.supplier
                  ? item.supplier.serviceType
                  : this.serviceType,
                stdOccupancy: item.service ? item.service.stdOccupancy : 1,
                isSelected: itemLinkedService ? true : false,
                serviceName: item.serviceName,
                supplierName: item.supplierName,
                supplierId: item.supplierId,
                price: itemLinkedService
                  ? itemLinkedService.price
                  : item.priceFrom,
                isMandatory: isMandatory,
                notInUse: notInUse,
              };
            })
            .filter((item) => !item.notInUse)
        : [];
    },
    onSave(item) {
      this.$emit("save", item);
    },
  },

  apollo: {
    availableLinkedServices: {
      query: AVAILABLE_LINKED_SERVICES,
      variables() {
        return {
          destinationId: this.destinationId,
          agentId: this.agentId,
          department: this.department,
          startDate: this.startDate,
          endDate: this.endDate,
          serviceType: this.serviceType,
          adults: this.adults,
          children: this.children,
          infants: this.infants,
          //only services present in the serviceLinkedServicesData, excluding not-in-use target services
          services: this.serviceLinkedServicesData
            .filter(
              (ls) =>
                this.servicesIds.includes(ls.targetService.id) &&
                !ls.targetService.notInUse
            )
            .map((ls) => ls.targetService.id),
          marketplace: this.marketplace,
        };
      },
      skip() {
        return (
          this.servicesIds.length === 0 ||
          this.serviceLinkedServicesData.length === 0
        );
      },
      result(result) {
        this.linkedServicesItems = this.getLinkedServicesItems();
      },
    },
    serviceLinkedServicesInfo: {
      query: SERVICE_LINKED_SERVICES_INFO,
      variables() {
        return {
          filter: {
            sourceServiceId_eq: this.serviceId,
            targetServices_ids_in: this.servicesIds,
            dateFrom_lte: this.startDate,
            dateTo_gte: this.endDate,
          },
          marketplace: this.marketplace,
        };
      },
      skip() {
        return (
          this.servicesIds.length === 0 || this.serviceId.toString() === ""
        );
      },
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/ItemLinkedServicesList.vue